import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icons' // icon
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

// 分页组件
// import Pagination from '@/components/Pagination'
Vue.use(ElementUI)
// Vue.component('Pagination', Pagination)
Vue.use(Viewer)
Vue.config.productionTip = true


new Vue({
  router: router.router,
  store,
  render: h => h(App)
}).$mount('#app')
